function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useQuery } from '@tanstack/react-query';
import { canMangeConfigKey, getCanManageTeam } from '@ui/guards/org-team';
import { useCurrentUser } from './current-user';
function canManageTeamQuery(param) {
    let { organization, team, user, members } = param;
    var _ref, _ref1, _ref2, _ref3;
    return {
        queryKey: [
            canMangeConfigKey,
            (_ref = organization === null || organization === void 0 ? void 0 : organization.id) !== null && _ref !== void 0 ? _ref : '',
            (_ref1 = organization === null || organization === void 0 ? void 0 : organization.name) !== null && _ref1 !== void 0 ? _ref1 : '',
            (_ref2 = team === null || team === void 0 ? void 0 : team.id) !== null && _ref2 !== void 0 ? _ref2 : '',
            (_ref3 = user === null || user === void 0 ? void 0 : user.id) !== null && _ref3 !== void 0 ? _ref3 : ''
        ],
        queryFn: ()=>{
            if (!organization || !team || !user || !members) {
                return Promise.resolve(false);
            }
            return getCanManageTeam(organization, user, team, members);
        },
        enabled: !!members
    };
}
export function useUserCanManageTeam(params) {
    const { user } = useCurrentUser();
    const { isLoading, data: can, error } = useQuery(canManageTeamQuery(_object_spread_props(_object_spread({}, params), {
        user
    })));
    return {
        can,
        isLoading,
        error
    };
}
